/* eslint-disable import/no-cycle */
import Cookies from "js-cookie";
import { ICourse } from "../inputForm/courseDataList"; 

const favoriteCourse = (event: React.MouseEvent<SVGElement, MouseEvent>, course: ICourse ) => {

  event.stopPropagation();
  const isThereFavCourses = Cookies.get('favCourses');
  let favoriteCourses: ICourse[] = [];

  // If already threr are favorited courses in cookies, add them to the array.
  if (isThereFavCourses !== undefined) favoriteCourses = JSON.parse(isThereFavCourses);

  // If the clicked course was already found in the cookies, un-favorite it (delete it from the array and mark favorite as false).
  if (favoriteCourses.some(favCourse => favCourse.code === course.code)){
    const index = favoriteCourses.findIndex((favCourse)=>course.code === favCourse.code);
    favoriteCourses.splice(index,1);
    course.favorite = false;
  }
  // Else, add it to the array and mark it as true.
  else { 
    course.favorite = true;
    favoriteCourses.push(course);
  }

  //Eliminate redundancy, update cookies, and return the favorites array.
  favoriteCourses = [...new Set (favoriteCourses)];
  const expirationDate = new Date();
  expirationDate.setFullYear(expirationDate.getFullYear() + 1);  // Set the cookie with an expiration date
  Cookies.set('favCourses', JSON.stringify(favoriteCourses), { expires: expirationDate });
  return favoriteCourses;
}

export default favoriteCourse;